package com.crowpay.extensions

import com.crowpay.Owner

fun Owner.isValid(): Boolean =
    legalFirstName.isNotBlank() && legalLastName.isNotBlank() && address.isNotBlank() && ownership > 0 &&
            title.isNotBlank() && birthDate != null && ssnDisplay.isNotBlank() && ssnDisplay.length == 9